// COMMISSION — quiet, formal application form. Two-column on desktop.
export default function Commission() {
  return (
    <div className="bg-[#0B0A0E] text-white">
      <section className="pt-32 pb-12 max-w-[1500px] mx-auto px-8 lg:px-14 border-b border-white/10">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#C9B68B] mb-4">— Commission</p>
        <h1 className="font-serif text-[48px] lg:text-[112px] leading-[0.92] tracking-[-0.02em] max-w-5xl">Tell us, <span className="italic text-[#C9B68B]">a little</span>.</h1>
        <p className="font-serif italic text-lg lg:text-xl text-white/65 mt-6 max-w-2xl">Two stones a year. The waiting list is currently fourteen months. We will reply, in person, within five working days.</p>
      </section>

      <section className="max-w-[1500px] mx-auto px-8 lg:px-14 py-20 grid lg:grid-cols-[1fr_1.5fr] gap-12 lg:gap-20">
        <aside className="space-y-8">
          <div className="border border-[#C9B68B]/25 p-8 bg-[#15131A]">
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#C9B68B] mb-2">Maître Joaillier</p>
            <p className="font-serif text-2xl">Klara Lumen</p>
            <p className="text-sm text-white/65 mt-3 leading-[1.7]">Antwerp Diamond Bourse, master diamantair, certified 1991. Trained at the Academie voor Diamanthandel under Henri van Mol.</p>
          </div>
          <div className="border-l-2 border-[#C9B68B]/40 pl-6">
            <p className="font-serif text-2xl text-white/85">Antwerp atelier</p>
            <p className="text-sm text-white/55 mt-2 leading-relaxed">Pelikaanstraat 14<br />2018 Antwerp · Belgium</p>
            <p className="font-mono text-[11px] text-white/45 mt-2">+32 3 555 0184</p>
          </div>
          <div className="border-l-2 border-[#C9B68B]/40 pl-6">
            <p className="font-serif text-2xl text-white/85">London showing</p>
            <p className="text-sm text-white/55 mt-2 leading-relaxed">86 Mount Street, Mayfair<br />London W1K 2SP</p>
            <p className="font-mono text-[11px] text-white/45 mt-2">+44 20 7993 0184</p>
          </div>
        </aside>

        <form className="space-y-7 bg-[#15131A] border border-[#C9B68B]/20 p-8 lg:p-12" onSubmit={(e) => e.preventDefault()}>
          <Field label="Your name" testId="jewel-comm-name" />
          <div className="grid sm:grid-cols-2 gap-5">
            <Field label="Telephone" type="tel" testId="jewel-comm-tel" />
            <Field label="Email" type="email" testId="jewel-comm-email" />
          </div>
          <div>
            <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#C9B68B] block mb-2">Type of piece</label>
            <select data-testid="jewel-comm-type" className="w-full bg-transparent border-b border-white/30 py-3 outline-none focus:border-[#C9B68B] font-serif text-base text-white">
              {['Solitaire — engagement', 'Wedding band(s)', 'Earrings — pair', 'Necklace / Pendant', 'Bracelet — line / tennis', 'Brooch / Tiara / Other', 'Stone-only — to be set later'].map(o => <option key={o} className="bg-[#0B0A0E]">{o}</option>)}
            </select>
          </div>
          <div>
            <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#C9B68B] block mb-2">Indicative budget</label>
            <select data-testid="jewel-comm-budget" className="w-full bg-transparent border-b border-white/30 py-3 outline-none focus:border-[#C9B68B] font-serif text-base text-white">
              {['£100k — 250k', '£250k — 500k', '£500k — 1m', '£1m — 3m', 'Above £3m'].map(o => <option key={o} className="bg-[#0B0A0E]">{o}</option>)}
            </select>
          </div>
          <div>
            <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#C9B68B] block mb-2">Notes</label>
            <textarea data-testid="jewel-comm-notes" rows="5" placeholder="Any inheritance, occasion, stones owned, sketches you like…" className="w-full bg-transparent border-b border-white/30 py-3 outline-none focus:border-[#C9B68B] resize-none font-serif text-base placeholder:text-white/30" />
          </div>
          <p className="font-mono text-[10px] text-white/45 leading-relaxed border-t border-white/10 pt-4">All correspondence is confidential. Stones owned remain with you until delivery.</p>
          <button type="button" data-testid="jewel-comm-submit" className="bg-[#C9B68B] text-[#0B0A0E] px-9 py-4 font-mono text-[10px] tracking-[0.32em] uppercase hover:bg-white transition-colors">Send to the atelier →</button>
        </form>
      </section>
    </div>
  );
}
function Field({ label, type = 'text', testId }) {
  return (
    <div>
      <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#C9B68B] block mb-2">{label}</label>
      <input data-testid={testId} type={type} className="w-full bg-transparent border-b border-white/30 py-3 outline-none focus:border-[#C9B68B] font-serif text-base text-white" />
    </div>
  );
}
